// MUI Imports
import { Button, Card, CardContent, Typography } from "@mui/material";

// Icons Imports
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

const Pagination = ({ currentPage, totalPages, setCurrentPage }) => {
  const scrollToTop = () => {
    window.scrollTo({
      top: 250,
      behavior: "smooth",
    });
  };

  const handlePrevious = () => {
    if (currentPage > 1) {
      setCurrentPage((prev) => prev - 1);
      setTimeout(() => {
        scrollToTop();
      }, 100);
    }
  };

  const handleNext = () => {
    if (currentPage < totalPages) {
      setCurrentPage((prev) => prev + 1);
      setTimeout(() => {
        scrollToTop();
      }, 100);
    }
  };

  return (
    <Card
      sx={{
        borderRadius: "25px",
      }}
    >
      <CardContent
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "3px!important",
        }}
      >
        <Button
          onClick={handlePrevious}
          sx={{
            visibility: currentPage === 1 ? "hidden" : "visible",

            textTransform: "none",
            fontSize: { xs: "14px", sm: "18px", md: "20px" },
            fontWeight: 100,
            padding: {
              xs: "4px 16px 4px 12px",
              sm: "8px 22px 6px 20px",
            },
            borderRadius: "25px",
            color: "#718096",
            backgroundColor: "#e2e8f0",
            "&:hover": {
              backgroundColor: "#667EEA",
              color: "#fff", // Prevents background change
            },
          }}
        >
          <ChevronLeftIcon
            sx={{
              fontSize: { xs: "16px", sm: "20px", md: "28px" },
              fontWeight: "bold",
              marginRight: { xs: "8px", sm: "10px", md: "20px" },
            }}
          />
          Previous
        </Button>

        <Typography
          variant="body1"
          sx={{
            fontSize: { xs: "10px", sm: "14px", md: "16px" },
            color: "#5f6368",
          }}
        >
          <span style={{ fontWeight: 400 }}>Page </span>
          <span style={{ fontWeight: 700 }}>{currentPage} </span>
          <span style={{ fontWeight: 400 }}>of </span>
          <span style={{ fontWeight: 700 }}>{totalPages}</span>
        </Typography>

        {/* Next Button */}
        <Button
          onClick={handleNext}
          disabled={currentPage === totalPages}
          sx={{
            textTransform: "none",
            fontSize: { xs: "14px", sm: "18px", md: "20px" },
            fontWeight: 100,
            padding: {
              xs: "4px 6px 4px 18px",
              sm: "6px 10px 6px 22px",
              md: "8px 12px 8px 36px",
            },
            borderRadius: "25px",
            color: "#fff",
            visibility: currentPage === totalPages ? "hidden" : "visible",

            backgroundColor: "#718096",
            "&:hover": {
              backgroundColor: "#667EEA",
            },
          }}
        >
          Next
          <ChevronRightIcon
            sx={{
              fontSize: { xs: "16px", sm: "20px", md: "28px" },
              fontWeight: "bold",
              marginLeft: { xs: "8px", sm: "10px", md: "20px" },
            }}
          />
        </Button>
      </CardContent>
    </Card>
  );
};

export default Pagination;
